// extracted by mini-css-extract-plugin
module.exports = {"item":"item--1eMYv","reverse":"reverse--1Os5C","textWrap":"textWrap--19f4Z","imageWrap":"imageWrap--1EmAm"};